import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static values = { url: String };
  static targets = [
    "startDaysInput", "endDaysInput",
    "startDatePickerInput", "endDatePickerInput"
  ];

  connect() {
    this._boundSaveIfChanged = this._saveIfChanged.bind(this);

    if (this.hasStartDaysInputTarget) {
      this.startDaysInputTarget.addEventListener("blur", this._boundSaveIfChanged);
      this.startDaysInputTarget.addEventListener("change", this._boundSaveIfChanged);
    }
    if (this.hasEndDaysInputTarget) {
      this.endDaysInputTarget.addEventListener("blur", this._boundSaveIfChanged);
      this.endDaysInputTarget.addEventListener("change", this._boundSaveIfChanged);
    }

    this._lastSavedStartDays = this.hasStartDaysInputTarget ? this.startDaysInputTarget.value : "";
    this._lastSavedEndDays = this.hasEndDaysInputTarget ? this.endDaysInputTarget.value : "";
  }

  disconnect() {
    if (this.hasStartDaysInputTarget) {
      this.startDaysInputTarget.removeEventListener("blur", this._boundSaveIfChanged);
      this.startDaysInputTarget.removeEventListener("change", this._boundSaveIfChanged);
    }
    if (this.hasEndDaysInputTarget) {
      this.endDaysInputTarget.removeEventListener("blur", this._boundSaveIfChanged);
      this.endDaysInputTarget.removeEventListener("change", this._boundSaveIfChanged);
    }
  }

  _saveIfChanged(event) {
    let currentStartDays = this.hasStartDaysInputTarget ? this.startDaysInputTarget.value : "";
    let currentEndDays = this.hasEndDaysInputTarget ? this.endDaysInputTarget.value : "";

    if (event?.detail?.value !== undefined) {
      const syncedValue = String(event.detail.value);

      if (this.hasStartDaysInputTarget && event.currentTarget === this.startDaysInputTarget) {
        currentStartDays = syncedValue;
      } else if (this.hasEndDaysInputTarget && event.currentTarget === this.endDaysInputTarget) {
        currentEndDays = syncedValue;
      }
    }

    if (currentStartDays === this._lastSavedStartDays &&
        currentEndDays === this._lastSavedEndDays) return;

    this._lastSavedStartDays = currentStartDays;
    this._lastSavedEndDays = currentEndDays;
    this.saveDates(currentStartDays, currentEndDays);
  }

  saveDates(startDays, endDays) {
    const body = new FormData();

    if (startDays === undefined) {
      startDays = this.hasStartDaysInputTarget ? this.startDaysInputTarget.value : "";
    }
    if (endDays === undefined) {
      endDays = this.hasEndDaysInputTarget ? this.endDaysInputTarget.value : "";
    }

    if (startDays !== "" && startDays !== undefined) {
      body.append("program_module[start_date_reference_attributes][offset]", `${startDays} days`);
      body.append("program_module[start_date_reference_attributes][anchor]", "start_at");
    } else {
      body.append("program_module[start_date_reference_attributes][_destroy]", "1");
    }

    if (endDays !== "" && endDays !== undefined) {
      body.append("program_module[end_date_reference_attributes][offset]", `${endDays} days`);
      body.append("program_module[end_date_reference_attributes][anchor]", "start_at");
    } else {
      body.append("program_module[end_date_reference_attributes][_destroy]", "1");
    }

    this._lastSavedStartDays = startDays;
    this._lastSavedEndDays = endDays;

    Rails.ajax({
      url: this.urlValue,
      type: "PATCH",
      data: body,
      headers: {
        'Content-Type': 'application/json'
      },
      dataType: "script",
      success: (res) => {}
    });
  }

  clearDates() {
    if (this.hasStartDatePickerInputTarget) {
      this.startDatePickerInputTarget.dispatchEvent(
        new CustomEvent("promote:datepicker-change", { detail: { value: "" } })
      );
    }
    if (this.hasEndDatePickerInputTarget) {
      this.endDatePickerInputTarget.dispatchEvent(
        new CustomEvent("promote:datepicker-change", { detail: { value: "" } })
      );
    }

    if (this.hasStartDaysInputTarget) this.startDaysInputTarget.value = "";
    if (this.hasEndDaysInputTarget) this.endDaysInputTarget.value = "";

    this.saveDates();
  }
}
